import React from "react";
import styles from "../../../styles/charts/chartStyle.module.css";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { toShortNumber } from "../../../lib/util";

// This is the improved component of LineChart as here the labels is included in the point itself and the type key decides whether it needs to be Line chart or Area Chart
interface AreaLineChartProps {
  title?: string;
  chartData: any[];
  xLabel?: string;
  yLabel?: string;
  xAxisDateTime?: boolean;
  type?: "area" | "line";
  // This is to decide the padding between xaxis and its label
  xAxisOffset?: number;
  maxY?: number;
  minY?: number;
  extraYOffset?: number;
}
const AreaLineChart = (props: AreaLineChartProps) => {
  const {
    xAxisDateTime = false,
    type = "area",
    xAxisOffset = 70,
    maxY,
    minY,
    xLabel,
    yLabel,
    title,
    extraYOffset,
  } = props;

  let options = {
    title: {
      text: props.title,
      offsetY: 0,
      align: "center" as "center",
      style: {
        color: "#000000",
        fontWeight: "500",
        fontSize: "18px",
      },
    },
    chart: {
      type: "area",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: xLabel,
            headerValue: yLabel,
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
    },

    stroke: {
      show: true,
      // curve: "smooth",
      // lineCap: "butt",
      colors: undefined,
      width: 3,
      // dashArray: 0,
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      "#008FFB",
      "#01E396",
      "#FEB019",
      "#FF4560",
      "#775DD0",
      // "#3b81f1",
      "#ccccff",
      "#7fdfff",
      "#81a432",
      "#68228b",
      "#00563f",
      "#674937",
      "#621b18",
      "#68228b",
    ],
    xaxis: {
      // range: 3,
      tickPlacement: "between",
      type: xAxisDateTime ? "datetime" : undefined,
      forceNiceScale: true,
      // categories: [0, 100],
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: true,
        rotate: 0, //-30
        // style: {
        //   color: "#000000",
        //   fontWeight: "500",
        //   fontSize: "12px",
        // },
      },
      title: {
        text: props.xLabel,
        offsetY: extraYOffset! ? extraYOffset + xAxisOffset : xAxisOffset,
        style: {
          color: "#000000",
          fontWeight: "500",
          fontSize: "16px",
        },
      },
    },
    yaxis: {
      max: maxY,
      min: minY,
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: true,
        rotate: 0,
        formatter: toShortNumber,
      },
      title: {
        text: props.yLabel,
        offsetY: 0,
        style: {
          color: "#000000",
          fontWeight: "500",
          fontSize: "16px",
        },
      },
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      onItemClick: {
        toggleDataSeries: true,
      },
    },
    noData: {
      text: "Loading...",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };

  let series = props.chartData;

  return (
    <ReactApexChart
      className={styles.the_chart}
      options={options as ApexOptions}
      series={series}
      type={type}
    />
  );
};

export default AreaLineChart;
